/** Helper function to make Node/Browser wait for a period of time. */
export const sleep = (timeoutMs: number): Promise<void> =>
  // NOTE: Node runner seems to be rounding so it's possible to wait timeoutMs - .5 which technically
  // isn't sleeping at least timeoutMs.
  new Promise(resolve => setTimeout(resolve, timeoutMs + 1));
